import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Common/Button/Button";
// import FileUpload from "../../components/Common/FileUpload/FileUpload";
import Input from "../../components/Common/Input/Input";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { validations } from "../../utils/validations";
import AttachmentIcon from "../../components/Common/SvgIcons/CustomSvgIcons/AttachmentIcon";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import classes from "./ContactUsPage.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { contactUsActionHandler } from "../../store/actions/actionHandlers/commonActionHandler";
import { setErrorHandler } from "../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../utils/errorTypes";
import { FormattedMessage, injectIntl } from "react-intl";

export const schema = yup.object().shape({
  addDescription: yup
    .string().trim()
    .max(1000, "You have already enter 1000 character"),
});
const ContactUsPage = ({ intl }) => {
  const dispatch = useDispatch();

  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile } = commonState;
  const chooseFromGal = React.useRef(null);
  const [value, setValueTest] = useState();
  const [newQueryName, setNewQueryName] = useState();
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const [fileBinaryData, setfileBinaryData] = useState();
  const [file, setFile] = useState();
  const [selectedFileName, setSelectedFileName] = useState();
  const [count, setCount] = useState("1000");

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    resolver: yupResolver(schema),
  });
  const subjectArr = [
    {
      id: 1,
      val: intl.formatMessage({
        id: `CONTACTUS_OP0`,
      }),
    },
    {
      id: 2,
      val: intl.formatMessage({
        id: `CONTACTUS_OP1`,
      }),
    },
    {
      id: 3,
      val: intl.formatMessage({
        id: `CONTACTUS_OP2`,
      }),
    },
    {
      id: 4,
      val: intl.formatMessage({
        id: `CONTACTUS_OP3`,
      }),
    },
  ];
  const {
    handleSubmit,
    watch,
    reset,
    unregister,
    formState: { errors },
  } = methods;

  let maxSize = 1048576 * 5;
  const [fileSize, setFileSize] = useState();
  const [fileFormat, setFileFormat] = useState();
  const handleselectedFile = (event) => {
    event.preventDefault();
    let reader = new FileReader();
    let files = event.target.files[0];
    setFileSize(files.size);
    // setFileFormat();
    var allowedFormat = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "doc",
      "docx",
      "xls",
      "ppt",
      "pps",
      "pptx",
      "txt",
      "pdf",
      "html",
      "xps",
      "xlsx",
    ];
    reader.readAsBinaryString(files);
    // let filetype = files.name.slice(files.name.indexOf(".") + 1);
    // let filename = files.name;
    // reader.readAsBinaryString(files);
    if (
      files !== undefined &&
      // && (files.type === "image/png" || files.type === "image/jpeg")
      files.size <= maxSize
    ) {
      reader.onload = (event) => {
        var base64images = reader.result.slice(
          reader.result.indexOf(",") + 1,
          reader.result.length
        );
        setSelectedFileName(files.name);
        setFile(files);
        setfileBinaryData(files);
        handleImageUrl(base64images);
      };
      setFile(file);
      // reader.readAsDataURL(files);
    } else if (files === undefined) {
      setSelectedFileName(files.name);
      setFile("");
      handleImageUrl("");
      chooseFromGal.current.value = "";
    } else if (files.size > maxSize) {
      // setSelectedFileName(null);
      // setFile(files);
      // handleImageUrl("");
      // chooseFromGal.current.value = "";
      unregister("contactUsAttachmentFile");
      dispatch(
        setErrorHandler(
          errorTypes.FAIL,
          "Max file size should not be greater than 5MB"
        )
      );
    }
    if (!allowedFormat.includes(files.name.split(".")[1])) {
      unregister("contactUsAttachmentFile");
      dispatch(setErrorHandler(errorTypes.FAIL, "Please attach below given formats only"));
    }
  };
  const [loader, setLoader] = useState(false)
  const onSubmit = (data) => {
    setLoader(true);
    if (fileSize > maxSize) {
      dispatch(
        setErrorHandler(
          errorTypes.FAIL,
          "Please Upload File having size is less than 5MB"
        )
      );
    } else {
      let queries = {
        From: null,
        Subject: null,
        Message: null,
        attachfile: false,
        timestamp: null,
        fileExtension: null,
        // FileName: null,
        // FileData: null,
        // FileType: null,
      };
      let today = new Date();
      let CreatedDate =
        today
          .toLocaleDateString()
          .replace(
            /[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g,
            ""
          ) +
        " " +
        today
          .toLocaleTimeString()
          .replace(
            /[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g,
            ""
          );
      queries.From = myProfile.EmailId;
      queries.Subject = data.contactOption;
      queries.Message = data.addDescription;
      queries.attachfile = imagePreviewUrl ? true : false;
      queries.timestamp = CreatedDate;
      // queries.FileData = imagePreviewUrl;
      // queries.FileName = file?.name;
      queries.fileExtension = file?.name?.slice(file?.name?.indexOf(".") + 1);
      // queries.FileType = file?.type;
      dispatch(contactUsActionHandler(queries, fileBinaryData)).then((response) => {
        if(response.status === 200){
          setLoader(false);
        }
      });
      // console.log(queries)
      reset();
      setCount(1000);
    }
  };

  const handleClick = (e) => {
    chooseFromGal.current.click();
    setFile("");
  };
  const handleImageUrl = (url) => {
    setImagePreviewUrl(url);
  };
  const handleChange = (e) => {
    setValueTest(e.target.value);
  };
  const contactUs = watch(
    ["contactOption", "addDescription", "contactUsAttachmentFile"],
    false
  );
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.contactUs__main}>
          <div className={classes.contactUs__main__labelInput}>
            <Input
              type="select"
              name="contactOption"
              label={"Select An Option For Contact"}
              placeholder={"Select An Option"}
              error={errors.ContactOption?.message}
              validations={validations(true, "Please select an option")}
              fieldName="val"
              labelColor
              valueArr={subjectArr}
              onChange={handleChange}
            />
          </div>
          <div className={classes.contactUs__main__labelInput}>
            <div className={classes.contactUs__main__labelInput__textArea}>
              <Input
                label={"Add Description"}
                name="addDescription"
                placeholder={"Enter Contact Related Description"}
                type="textarea"
                error={errors?.addDescription?.message}
                validations={validations(true, 1000)}
                textAreaScrollable
                labelColor
                rows="4"
                labelMsg="(Max : 1000 Characters)"
                maxLength={1000}
                onChange={(e) =>
                  setCount(Math.abs(e.target.value.trim().length - 1000))
                }
                // style={{ borderRadius: "0.8rem" }}
              />
              <div className={classes.contactUs__main__labelInput__charCount}>
                {count} <FormattedMessage id="CHARACTERS_REMAINING" />
              </div>
            </div>
          </div>
          <div className={classes.contactUs__main__labelInput}>
            <Input
              type="file"
              reference={chooseFromGal}
              name="contactUsAttachmentFile"
              onChange={handleselectedFile}
              fileInputName={false}
              fileInputButton={false}
              hidden
              fileInputButtonWidth="0"
              gap="0"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.doc,.docx,.xls,.ppt,.pps,.pptx,.txt,.pdf,.html,.xps,.xlsx"
              height="0"
            />
            {!contactUs[2] && (
              <div className={classes.contactUs__main__labelInput__attachment}>
                <div
                  className={
                    classes.contactUs__main__labelInput__attachment__attacheFile
                  }
                  onClick={handleClick}
                >
                  <AttachmentIcon /> &nbsp;Attach File
                </div>
                <div
                  className={
                    classes.contactUs__main__labelInput__attachment__formatAllow
                  }
                >
                  {/* <strong
                    style={{ color: "rgb(112 111 111)", fontWeight: "600" }}
                  >
                    Format Supported:
                  </strong>{" "}
                  JPG/JPEG/PNG/GIF/BMP/DOC/DOCX/XLS/PPT/PPS/PPTX/TXT/PDF/HTML/XPS/XLSX */}
                  <FormattedMessage id="CONTCTUS_FORMAT" />
                </div>
                {/* &nbsp;Attach JPG/JPEG/PNG */}
              </div>
            )}
          </div>

          <div className={classes.contactUs__main__buttons}>
            <Link
              to={`/${localStorage.getItem(
                "tenantName"
              )}/userProfile/myProfile`}
            >
              <FormattedMessage id="CANCEL_TEXT" />
            </Link>
            <Button
              light
              label={<FormattedMessage id="CONTACTUS_SUBMIT" />}
              disabled={!contactUs[0] || !contactUs[1].trim().length > 0}
              backgroundColor={"fff !important"}
              borderColor={"#707070 !important"}
              width={"18.6"}
              height={"3.6"}
              borderRadius={"20"}
              type={"submit"}
              loading={loader}
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default injectIntl(ContactUsPage);
